const LabelInput = ( {Name}) => {
    return (
        <label>{Name}</label>
    );
  };
  export default LabelInput;
  